import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import React from "react";
import Price from "@components/base/Price/Price";

const BG = {
	blockTitle: '',
	blockDesc: '',
	priceColumnText: 'цена за подновяване',
	buttonText: '',
	buttonAction: '',
	buttonParams: [],
	ButtonModal: '',
	terms: {
		selected: 1,
		title: 'Показване на цени за:',
		options: [
			{
				id: 1,
				label: '1 месец',
				labelShort: '1 мес',
				months: 1,
				discountText: '',
				discountServiceType: 'ManagedVPS'
			},
			{
				id: 3,
				label: '3 месеца',
				labelShort: '3 мес',
				months: 3,
				discountText: '',
				discountServiceType: 'ManagedVPS'
			},
			{
				id: 6,
				label: '6 месеца',
				labelShort: '6 мес',
				months: 6,
				discountText: '',
				discountServiceType: 'ManagedVPS'
			},
			{
				id: 12,
				label: '12 месеца',
				labelShort: '12 мес',
				months: 12,
				discountText: '',
				discountServiceType: 'ManagedVPS'
			}
		]
	},
	plans: [
		{
			serviceId: 'vps_m_011',
			title: 'Managed VPS Start',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		},
		{
			serviceId: 'vps_m_020',
			title: 'Managed VPS Pro',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		},
		{
			serviceId: 'vps_m_021',
			title: 'Managed VPS Mega',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		},
		{
			serviceId: 'vps_m_030',
			title: 'Managed VPS Business',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		},
		{
			serviceId: 'vps_m_030_disk',
			title: 'Managed VPS Disk+',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		},
		{
			serviceId: 'vps_m_030_ram_cpu',
			title: 'Managed VPS Business (CPU/RAM+)',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		},
		{
			serviceId: 'vps_m_030_ram_cpu_disk',
			title: 'Managed VPS Business+',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		},
		{
			serviceId: 'vps_m_040',
			title: 'Managed VPS Enterprise',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		}
	],
	noteData: [
		<>
			* Добавяне на допълнително дисково пространство се предлага за планове Managed VPS Disk+,
			Managed VPS Business+ и Managed VPS Enterprise на фиксирана цена от{' '}
			<Price
			  serviceId={'mvps_additional_res'}
			  term={1}
			  layout={'PriceText'}
			/>
			{' '}с включен ДДС за 1 GB на месец.
		</>
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: '',
	blockDesc: '',
	priceColumnText: 'price for renew',
	buttonText: '',
	buttonAction: '',
	buttonParams: [],
	ButtonModal: '',
	terms: {
		selected: 1,
		title: 'Display prices for:',
		options: [
			{
				id: 1,
				label: '1 month',
				labelShort: '1 mo',
				months: 1,
				discountText: '',
				discountServiceType: 'ManagedVPS'
			},
			{
				id: 3,
				label: '3 months',
				labelShort: '3 mo',
				months: 3,
				discountText: '',
				discountServiceType: 'ManagedVPS'
			},
			{
				id: 6,
				label: '6 months',
				labelShort: '6 mo',
				months: 6,
				discountText: '',
				discountServiceType: 'ManagedVPS'
			},
			{
				id: 12,
				label: '12 months',
				labelShort: '12 mo',
				months: 12,
				discountText: '',
				discountServiceType: 'ManagedVPS'
			}
		]
	},
	plans: [
		{
			serviceId: 'vps_m_011',
			title: 'Managed VPS Start',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		},
		{
			serviceId: 'vps_m_020',
			title: 'Managed VPS Pro',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		},
		{
			serviceId: 'vps_m_021',
			title: 'Managed VPS Mega',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		},
		{
			serviceId: 'vps_m_030',
			title: 'Managed VPS Business',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		},
		{
			serviceId: 'vps_m_030_disk',
			title: 'Managed VPS Disk+',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		},
		{
			serviceId: 'vps_m_030_ram_cpu',
			title: 'Managed VPS Business (CPU/RAM+)',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		},
		{
			serviceId: 'vps_m_030_ram_cpu_disk',
			title: 'Managed VPS Business+',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		},
		{
			serviceId: 'vps_m_040',
			title: 'Managed VPS Enterprise',
			breadCrumbMode: 'ManagedVPS',
			priceType: 'renew',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: ''
		}
	],
	noteData: [
		<>
			* Additional disk space is available exclusively for Managed VPS Disk+, Managed VPS Business+,
			and Managed VPS Enterprise plans at a fixed price of{' '}
			<Price
			  serviceId={'mvps_additional_res'}
			  term={1}
			  layout={'PriceText'}
			/>
			, including VAT per 1 GB per month.
		</>
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];